import React, { useEffect, useState } from "react"
import { reactLocalStorage } from "reactjs-localstorage"
import './Profile.scss'
import tick from "../assets/icons/green_tick.png";
import { SendGuiDataEvents } from "../CommonScript";
function Profile({ status_txt,plan_text, validity_text}) {
    const [displayStatus, setDisplayStatus] = useState('')
    const plan=reactLocalStorage.get("planType");
    const validity=reactLocalStorage.get("validity");
    useEffect(() => {
        const displayStatus = reactLocalStorage.get("status_display")
        setDisplayStatus(displayStatus);
    }, [])

    function capitalizeFirstLetter(string) {
        if (string.toLowerCase() === 'failed') {
            string = "inactive"
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
            <div className="container m-w">
                <div className="columns is-mobile">
                    <div className="column is-full">
                        <div className="profile-card">
                            <div className="card-content ">
                                <div className="display line-bottom pb-3">
                                    <div className="profile-block">
                                        <h3 className="">{status_txt}
                                        </h3>
                                        {displayStatus ? <div className="user-status">
                                            <h2 className="mt-4 semibold">{capitalizeFirstLetter(displayStatus)} </h2>
                                            <img src={tick} alt="tick" className="image" style={{ marginTop: "1rem", marginLeft: ".25rem" }} />
                                        </div>
                                            : <h2 className="mt-4">--</h2>}
                                    </div>
                                    <div className="profile-block">
                                        <h3 className="">MSISDN</h3>
                                        {reactLocalStorage.get("msisdn") ? <h2 className="mt-4 semibold">{reactLocalStorage.get("msisdn")}</h2> :
                                            <h2 className="mt-4">--</h2>}
                                    </div>
                                </div>
                                <div className="display mt-3">
                                    <div className="profile-block">
                                        <h3 className="">{plan_text}
                                        </h3>
                                        {plan ? <div className="user-status">
                                            <h2 className="mt-4 semibold">{capitalizeFirstLetter(plan)} </h2>
                                            
                                        </div>
                                            : <h2 className="mt-4">--</h2>}
                                    </div>
                                    <div className="profile-block">
                                        <h3 className="">{validity_text}</h3>
                                        {reactLocalStorage.get("validity") ? <h2 className="mt-4 semibold">{validity}</h2> :
                                            <h2 className="mt-4">--</h2>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default Profile
